var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.37258 5.87258 0 12.5 0V0C19.1274 0 24.5 5.37258 24.5 12V12C24.5 18.6274 19.1274 24 12.5 24V24C5.87258 24 0.5 18.6274 0.5 12V12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77956 9.02667C9.24622 8.8 9.01956 8.14 9.33956 7.66C9.98622 6.7 11.0662 6 12.4929 6C14.0596 6 15.1329 6.71333 15.6796 7.60667C16.1462 8.37333 16.4196 9.80667 15.6996 10.8733C14.8996 12.0533 14.1329 12.4133 13.7196 13.1733C13.6196 13.3533 13.5596 13.5 13.5196 13.8C13.4596 14.2867 13.0596 14.6667 12.5662 14.6667C11.9862 14.6667 11.5129 14.1667 11.5796 13.5867C11.6196 13.2467 11.6996 12.8933 11.8862 12.56C12.3996 11.6333 13.3862 11.0867 13.9596 10.2667C14.5662 9.40667 14.2262 7.8 12.5062 7.8C11.7262 7.8 11.2196 8.20667 10.9062 8.69333C10.6729 9.07333 10.1862 9.19333 9.77956 9.02667ZM13.8329 17.3333C13.8329 18.0667 13.2329 18.6667 12.4996 18.6667C11.7662 18.6667 11.1662 18.0667 11.1662 17.3333C11.1662 16.6 11.7662 16 12.4996 16C13.2329 16 13.8329 16.6 13.8329 17.3333Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionMark);
export default __webpack_public_path__ + "static/media/circle-question-mark.db68477867850aae004b17ef86ee8d80.svg";
export { ForwardRef as ReactComponent };